import { render, staticRenderFns } from "./Appearance.vue?vue&type=template&id=811e8486&scoped=true&"
import script from "./Appearance.vue?vue&type=script&lang=js&"
export * from "./Appearance.vue?vue&type=script&lang=js&"
import style0 from "./Appearance.vue?vue&type=style&index=0&id=811e8486&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "811e8486",
  null
  
)

export default component.exports